export default __webpack_public_path__ + "static/forbes-7889aec1a0b02505bae734f9ae96bfe9.svg";